/**
 * Created by eriksundqvist on 13/05/16.
 */

/* @flow */
import React, {PropTypes} from 'react';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import Modal from 'react-modal';
import AddCoworkerContainer from './add-coworker-container';
import AddNewCoworkerContainer from './add-new-coworker-container';
import InvoiceUserEntity from '../../../frilans-finans/invoices/invoice-user-entity';
var _ = require('lodash');
import { ToolTip, CloseModal } from 'components';
import { processInvoiceUser } from 'redux/modules/invoice/helper';
import { toMoney, getLowHourlySalaryAmount } from '../amount/amount-helper';
import SupplierLedger from './supplier-ledger/supplier-ledger-container';
import TaxkeyService from 'frilans-finans/taxkeys/taxkey-service';
import { reformatInputValue } from '../invoice-tool-helper';
import InvoiceValidator from 'redux/modules/invoice/invoice-validator';
import * as DistributionRows from './rows/distribution-rows';

const CALCULATED_ITP = 'calculated-itp';
const CALCULATED_ITP_TAX = 'calculated-itp-tax';
const CALCULATED_VACATION_GROSS = 'calculated-vacation-gross';
const CALCULATED_TAX = 'calculated-tax';
const CALCULATED_EXPENSE = 'calculated-expense';
const CALCULATED_TO_PAY = 'calculated-to-pay';
const CALCULATED_TOTAL = 'calculated-total';
const CALCULATED_INVOICERY_FEE = 'calculated_invoicery_fee';
const CALCULATED_DISCOUNT = 'calculated_discount';
const CALCULATED_PAYROLL_TAX = 'calculated_payroll_tax';
const UPDATE_TAX_KEY = 'update-tax-key';
const UPDATE_GROSS_SALARY = 'update-gross-salary';
const UPDATE_NET_SALARY = 'update-net-salary';
const UPDATE_ALLOWANCE = 'update-allowance';
const UPDATE_TRAVEL = 'update-travel';
const HOURLY_SALARY_VACATION_INCLUDED = 'hourly-salary-vacation-included';
const HOURLY_SALARY_VACATION_EXCLUDED = 'hourly-salary-vacation-excluded';

export class Distribution extends React.Component {

  static propTypes = {
    taxkeys: PropTypes.array.isRequired,
    invoice: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    setTaxKeyId: PropTypes.func.isRequired,
    setInvoiceUser: PropTypes.func.isRequired,
    setAmountIncVat: PropTypes.func.isRequired,
    setLockAmountDistribution: PropTypes.func.isRequired,
    translationPrefix: PropTypes.string.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      addCoworkersModalIsOpen: false,
      addNewCoworkersModalIsOpen: false,
      userTaxKey: props.user.defaultTaxkeyId,
      justCalculated: null,
      currencyName: 'SEK',
      travelDeductionInfoRef: null,
      changeValue: {
        userId: null,
        value: 0,
        type: null
      },
      hideCalculation: true,
      showLowHourlySalaryModal: true
    };

    this.toggleDetails = this.toggleDetails.bind(this);
    this.toggleCalculation = this.toggleCalculation.bind(this);
    this.savedNewCoworker = this.savedNewCoworker.bind(this);
    this.onOpenAddCoworkerModal = this.onOpenAddCoworkerModal.bind(this);
    this.onCloseAddCoworkerModal = this.onCloseAddCoworkerModal.bind(this);
    this.onOpenAddNewCoworkerModal = this.onOpenAddNewCoworkerModal.bind(this);
    this.onCloseAddNewCoworkerModal = this.onCloseAddNewCoworkerModal.bind(this);
    this.getCoworkers = this.getCoworkers.bind(this);
    this.addCoworker = this.addCoworker.bind(this);
    this.getOmrKeys = this.getOmrKeys.bind(this);
    this.removeCoworker = this.removeCoworker.bind(this);
    this.amountInputBlur = this.amountInputBlur.bind(this);
    this.updateAmountFieldCurrency = this.updateAmountFieldCurrency.bind(this);
    this.setUserTaxKeyId = this.setUserTaxKeyId.bind(this);
    this.setInvoiceUserTaxKeyId = this.setInvoiceUserTaxKeyId.bind(this);
    this.setTaxKeyId = this.setTaxKeyId.bind(this);
    this.dummyOnChange = this.dummyOnChange.bind(this);
    this.lockAmountDistributionClick = this.lockAmountDistributionClick.bind(this);
    this.createInvoiceUserEntity = this.createInvoiceUserEntity.bind(this);
    this.getCalculationData = this.getCalculationData.bind(this);
    this.getHourlySalaryVacationExcluded = this.getHourlySalaryVacationExcluded.bind(this);
    this.grossSalaryInputBlur = this.grossSalaryInputBlur.bind(this);
    this.netSalaryInputBlur = this.netSalaryInputBlur.bind(this);
    this.allowanceBlur = this.allowanceBlur.bind(this);
    this.travelBlur = this.travelBlur.bind(this);
    this.setLockAmountDistribution = this.setLockAmountDistribution.bind(this);
    this.getTaxKeyIdByUserId = this.getTaxKeyIdByUserId.bind(this);
    this.updateInvoiceUser = this.updateInvoiceUser.bind(this);
    this.disableOnLock = this.disableOnLock.bind(this);
    this.renderLowHourlySalaryModal = this.renderLowHourlySalaryModal.bind(this);
    this.closeLowHourlySalaryModal = this.closeLowHourlySalaryModal.bind(this);
  }

  componentWillReceiveProps (nextProps) {
    if (!_.isEqual(nextProps, this.props)) {
      if (!_.isEqual(nextProps.invoice.invoiceUser, this.props.invoice.invoiceUser)) {
        for (let i = 0; i<nextProps.invoice.invoiceUser.length; i++) {
          let user = nextProps.invoice.invoiceUser[i];
          let prevUser = this.props.invoice.invoiceUser[i];
          if (user.calculation && prevUser && !_.isEqual(user.calculation, prevUser.calculation)) {
            this.refs['invoice-amount-' + user.userId].value = toMoney(user.calculation.amount);
          }

          if (user && prevUser && !_.isEqual(user.taxkeys, prevUser.taxkeys)) {
            this.setTaxKeyId(user.id, user.defaultTaxkeyId);
          }
        }
      }

      if (nextProps.invoice.lockAmountDistribution) {
        let nextLockAmountLength = Object.keys(
          nextProps.invoice.lockAmountDistribution
        ).length;
        let prevLockAmountLength = Object.keys(
          this.props.invoice.lockAmountDistribution
        ).length;
        if (nextLockAmountLength !== prevLockAmountLength) {
          for (let userId in nextProps.invoice.lockAmountDistribution) {
            this.refs['lock-amount-distribution-' + userId].checked = true;
          }
        }
      }

      const taxKeyHasChanged = nextProps.user.defaultTaxkeyId !== this.props.user.defaultTaxkeyId;

      if (!nextProps.invoice.invoiceId && taxKeyHasChanged) {
        this.setState({userTaxKey: nextProps.user.defaultTaxkeyId});
        this.setTaxKeyId(nextProps.user.id, nextProps.user.defaultTaxkeyId);
      } else if (nextProps.invoice.invoiceId) {
        this.setState({userTaxKey: this.getTaxKeyIdByUserId(nextProps.user.id)});
      }
    }
  }

  createInvoiceUserEntity (workerEntity) {
    let invoiceUserEntity = new InvoiceUserEntity(
      0,
      (workerEntity.address) ? workerEntity.address.co : workerEntity.co,
      (workerEntity.address) ? workerEntity.address.street : workerEntity.street,
      (workerEntity.address) ? workerEntity.address.zip : workerEntity.street,
      (workerEntity.address) ? workerEntity.address.city : workerEntity.street,
      (workerEntity.address) ? workerEntity.address.country : workerEntity.street,
      null,
      workerEntity.id,
      0,
      workerEntity.defaultTaxkeyId,
      0,
      workerEntity.firstName,
      workerEntity.lastName,
      workerEntity.accountClearingNumber || workerEntity.accountClearingNr,
      workerEntity.accountNumber || workerEntity.accountNr,
      null,
      false,
      '',
      workerEntity.saveVacationPay,
      workerEntity.saveItp,
      workerEntity.itpRate,
    );

    return invoiceUserEntity;
  }

  toggleDetails () {
    let hideDetailsStyle = this.refs.hideDetails.offsetParent ? 'none' : 'block';
    let showDetailsStyle = this.refs.showDetails.offsetParent ? 'none' : 'block';
    let showSummationStyle = this.refs.showSummation.offsetParent ? 'none' : 'flex';
    let detailsStyle = this.refs.details.offsetParent ? 'none' : 'block';

    this.refs.hideDetails.style.display = hideDetailsStyle;
    this.refs.showDetails.style.display = showDetailsStyle;
    this.refs.showSummation.style.display = showSummationStyle;
    this.refs.details.style.display = detailsStyle;
  }

  toggleCalculation () {
    let calculationStyle = this.refs.calculation.offsetParent ? 'none' : 'block';
    this.refs.calculation.style.display = calculationStyle;

    this.setState({
      hideCalculation: !this.state.hideCalculation
    });
  }

  renderAddCoworkerModal () {
    return (
      <Modal
        className='modal'
        contentLabel=''
        isOpen={this.state.addCoworkersModalIsOpen}>
        <div className='modal-content'>
          <button className='close' onClick={this.onCloseAddCoworkerModal}></button>
          <AddCoworkerContainer
            close={this.onCloseAddCoworkerModal}
            addNewCoworker={this.onOpenAddNewCoworkerModal}
            addCoworker={this.addCoworker} />
        </div>
      </Modal>
    );
  }

  renderAddNewCoworkerModal () {
    return (
      <Modal
        className='modal'
        contentLabel=''
        isOpen={this.state.addNewCoworkersModalIsOpen}>
        <div className='modal-content'>
          <button className='close' onClick={this.onCloseAddNewCoworkerModal}></button>
          <AddNewCoworkerContainer close={this.onCloseAddNewCoworkerModal} savedNewCoworker={this.savedNewCoworker} />
        </div>
      </Modal>
    );
  }

  addCoworker (workerEntity) {
    TaxkeyService.getWorkerTaxkeys(workerEntity.id)
      .then((response) => {
        let newInvoiceUser = this.createInvoiceUserEntity(workerEntity);
        newInvoiceUser.taxkeys = response;
        let invoiceUser = _.map(this.props.invoice.invoiceUser, (user) => {
          return Object.assign({}, user);
        });
        invoiceUser.push(newInvoiceUser);
        this.props.setInvoiceUser(invoiceUser);
        this.onCloseAddCoworkerModal();
      });
  }

  savedNewCoworker () {
    this.onOpenAddCoworkerModal();
  }

  onOpenAddCoworkerModal (event) {
    this.setState({
      addNewCoworkersModalIsOpen: false,
      addCoworkersModalIsOpen: true
    });
  }

  onOpenAddNewCoworkerModal (event) {
    this.setState({
      addCoworkersModalIsOpen: false,
      addNewCoworkersModalIsOpen: true
    });
  }

  onCloseAddCoworkerModal (event) {
    this.setState({
      addCoworkersModalIsOpen: false
    });
  }

  onCloseAddNewCoworkerModal (event) {
    this.setState({
      addNewCoworkersModalIsOpen: false,
      addCoworkersModalIsOpen: true
    });
  }

  setLockAmountDistribution (userId, forceSetting) {
    let lockAmountDistribution = Object.assign({}, this.props.invoice.lockAmountDistribution);
    let forceLock = !(forceSetting === undefined || forceSetting === false);

    if (lockAmountDistribution[userId] === undefined && !forceLock) {
      delete lockAmountDistribution[userId];
    } else if (lockAmountDistribution[userId] && forceLock) {
      delete lockAmountDistribution[userId];
    } else {
      lockAmountDistribution[userId] = true;
      this.refs['lock-amount-distribution-' + userId].checked = true;
    }

    this.props.setLockAmountDistribution(lockAmountDistribution);
  }

  lockAmountDistributionClick (event) {
    let invoiceUserId = event.target.id.replace('lock-amount-distribution-', '');
    this.setLockAmountDistribution(invoiceUserId, true);
  }

  removeCoworker (invoiceUserId) {
    let invoiceUser = _.map(this.props.invoice.invoiceUser, (user) => {
      return Object.assign({}, user);
    });
    invoiceUser = _.remove(invoiceUser, function (o) {
      return parseInt(o.userId) !== parseInt(invoiceUserId);
    });
    this.setLockAmountDistribution(invoiceUserId, false);
    this.props.setInvoiceUser(invoiceUser);
  }

  getOmrKeys (taxkeys) {
    return (
      taxkeys.map((taxkey, i) => {
        let taxKeyName = taxkey.taxkeyName;

        if (taxkey.payrollTax === 19.73) {
          taxKeyName = `${taxkey.taxAmount}%, 19-23 ${proxyCounterpart('YEARS')}`;
        }

        return (
          <option value={taxkey.id} key={i}>{taxKeyName}</option>
        );
      })
    );
  }

  amountInputBlur (event) {
    let total = event.target.value;
    total = reformatInputValue(total);
    let allInvoiceUser = _.map(this.props.invoice.invoiceUser, (user) => {
      return Object.assign({}, user);
    });

    let invoiceUserId = event.target.id.replace('invoice-amount-', '');
    this.setLockAmountDistribution(invoiceUserId, false);
    let invoiceUserEntity;

    for (let i = 0; i<allInvoiceUser.length; i++) {
      if (parseInt(allInvoiceUser[i].userId) === parseInt(invoiceUserId)) {
        invoiceUserEntity = allInvoiceUser[i];
      }
    }

    invoiceUserEntity.total = total;
    this.refs['invoice-amount-' + invoiceUserId].value = total;

    let invoiceUser = processInvoiceUser(invoiceUserEntity, allInvoiceUser);

    this.props.setInvoiceUser(invoiceUser);
  }

  updateAmountFieldCurrency () {
    let allInvoiceUser = _.map(this.props.invoice.invoiceUser, (user) => {
      return Object.assign({}, user);
    });
    for (let i = 0; i<allInvoiceUser.length; i++) {
      let amountInput = this.refs['invoice-amount-' + allInvoiceUser[i].userId];
      if (amountInput) {
        amountInput.value = amountInput.value;
      }
    }
  }

  setUserTaxKeyId (event) {
    let invoiceUserId = event.target.id.replace('invoice-taxkeyid-', '');
    let taxkeyId = event.target.value;
    this.setState({userTaxKey: taxkeyId});
    this.setTaxKeyId(invoiceUserId, taxkeyId);
  }

  setInvoiceUserTaxKeyId (event) {
    let invoiceUserId = event.target.id.replace('invoice-taxkeyid-', '');
    let taxkeyId = event.target.value;
    this.setTaxKeyId(invoiceUserId, taxkeyId);
  }

  setTaxKeyId (userId, taxkeyId) {
    this.updateInvoiceUser(userId, UPDATE_TAX_KEY, taxkeyId);
  }

  /*
  Needed to avoid warning on inputs only using onBlur
   */
  dummyOnChange (e) {
  }

  updateInvoiceUser (invoiceUserId, update, value) {
    let allInvoiceUser = _.map(this.props.invoice.invoiceUser, (user) => {
      return Object.assign({}, user);
    });

    let invoiceUserPostEntity;
    for (let i = 0; i<allInvoiceUser.length; i++) {
      if (parseInt(invoiceUserId) === parseInt(allInvoiceUser[i].userId)) {
        invoiceUserPostEntity = allInvoiceUser[i];
      }
    }

    let invoiceUser = [];

    if (invoiceUserPostEntity) {
      switch (update) {
        case UPDATE_TAX_KEY:
          let taxKey;
          for (let i = 0; i<invoiceUserPostEntity.taxkeys.length; i++) {
            if (parseInt(invoiceUserPostEntity.taxkeys[i].id) === parseInt(value)) {
              taxKey = invoiceUserPostEntity.taxkeys[i];
              break;
            }
          }

          if (taxKey) {
            invoiceUserPostEntity.taxkeyId = taxKey.id;
            invoiceUserPostEntity.payroll_tax = taxKey.payrollTax;
          }
          break;

        case UPDATE_GROSS_SALARY:
          invoiceUserPostEntity.gross = value;
          break;

        case UPDATE_NET_SALARY:
          invoiceUserPostEntity.net = value;
          break;

        case UPDATE_ALLOWANCE:
          invoiceUserPostEntity.allowance = value;
          break;

        case UPDATE_TRAVEL:
          invoiceUserPostEntity.travel = value;
          break;
      }

      invoiceUser = processInvoiceUser(invoiceUserPostEntity, allInvoiceUser);
      this.props.setInvoiceUser(invoiceUser);
    }
  }

  grossSalaryInputBlur (event) {
    let invoiceUserId = event.target.id.replace('invoice-gross-', '');
    let grossSalaryValue = event.target.value;

    grossSalaryValue = reformatInputValue(grossSalaryValue);

    this.setLockAmountDistribution(invoiceUserId, false);
    this.updateInvoiceUser(invoiceUserId,
      UPDATE_GROSS_SALARY,
      grossSalaryValue
    );
  }

  netSalaryInputBlur (event) {
    let invoiceUserId = event.target.id.replace('invoice-net-', '');
    let netSalaryValue = event.target.value;

    netSalaryValue = reformatInputValue(netSalaryValue);

    this.setLockAmountDistribution(invoiceUserId, false);
    this.updateInvoiceUser(invoiceUserId,
      UPDATE_NET_SALARY,
      netSalaryValue
    );
  }

  disableOnLock (userId) {
    return (this.props.invoice.lockAmountDistribution[userId] !== undefined);
  }

  allowanceBlur (event) {
    let invoiceUserId = event.target.id.replace('invoice-allowance-', '');
    let allowanceValue = event.target.value;

    allowanceValue = reformatInputValue(allowanceValue);

    if (allowanceValue === null) {
      this.refs[event.target.id].value = '0';
      allowanceValue = 0;
    }

    this.updateInvoiceUser(invoiceUserId,
      UPDATE_ALLOWANCE,
      allowanceValue
    );
  }

  travelBlur (event) {
    let invoiceUserId = event.target.id.replace('invoice-travel-', '');
    let travelValue = event.target.value;

    travelValue = reformatInputValue(travelValue);

    if (travelValue === null) {
      this.refs[event.target.id].value = '0';
      travelValue = 0;
    }

    this.updateInvoiceUser(invoiceUserId,
      UPDATE_TRAVEL,
      travelValue
    );
  }

  focus (e) {
    e.target.select();
  }

  setChangeValue (value, userId, type) {
    this.setState({
      changeValue: {
        type: type,
        value: value,
        userId: userId
      }
    });
  }

  getCoworkers () {
    let getOmrKeys = this.getOmrKeys;
    let removeCoworker = this.removeCoworker;
    let amountInputBlur = this.amountInputBlur;
    let setInvoiceUserTaxKeyId = this.setInvoiceUserTaxKeyId;
    let currencyName = this.state.currencyName;
    let changeValue = this.state.changeValue;
    let setChangeValue = this.setChangeValue.bind(this);
    let loggedInUserId = this.props.user.id;
    let getCalculationData = this.getCalculationData;
    let grossSalaryInputBlur = this.grossSalaryInputBlur;
    let netSalaryInputBlur = this.netSalaryInputBlur;
    let allowanceBlur = this.allowanceBlur;
    let travelBlur = this.travelBlur;
    let disableOnLock = this.disableOnLock;
    let focus = this.focus;
    let renderWorkerSumAccount = this.renderWorkerSumAccount;
    let renderWorkerSumItp = this.renderWorkerSumItp;
    let renderWorkerSumVacation = this.renderWorkerSumVacation;
    let renderworkerSumTotal = this.renderworkerSumTotal;
    let renderLockAmountContainer = this.renderLockAmountContainer.bind(this);

    return (
      <div>
        {this.props.invoice.invoiceUser.map(function (invoiceUser, i) {
          if (parseInt(invoiceUser.userId) === parseInt(loggedInUserId)) {
            return;
          }

          return (
            <div key={i}>
              <div className='coworkers-divider'></div>
              <DistributionRows.CoworkerName
                invoiceUser={invoiceUser}
                coworkerId={+invoiceUser.userId}
                removeCoworker={removeCoworker}
              />
              <DistributionRows.Divider />
              <div className='invoice-amount'>
                <div className='details-left'>
                  <Translate className='bold' content='AMOUNT_TO_BILL_EXCL_VAT'/>
                  {renderLockAmountContainer('hide-until-mobile', invoiceUser.userId)}
                </div>
                <div className='details-right'>
                  {renderLockAmountContainer('hide-mobile', invoiceUser.userId)}
                  <div className='currency-input-holder' data-currency={currencyName}>
                    <input
                      type='text'
                      id={'invoice-amount-' + invoiceUser.userId}
                      ref={'invoice-amount-' + invoiceUser.userId}
                      onBlur={amountInputBlur}
                      disabled={disableOnLock(invoiceUser.userId)}
                      onClick={focus}
                      defaultValue={'0'}
                    />
                  </div>
                </div>
              </div>
              <DistributionRows.InvoiceryFee
                calculation={getCalculationData(invoiceUser.userId, CALCULATED_INVOICERY_FEE)}
              />
              <DistributionRows.Divider />
              <DistributionRows.PayrollTax
                calculation={getCalculationData(invoiceUser.userId, CALCULATED_PAYROLL_TAX)}
              />
              <DistributionRows.Divider />
              <DistributionRows.Gross
                invoiceUser={invoiceUser}
                value={changeValue}
                disabled={disableOnLock(invoiceUser.userId)}
                focus={focus}
                currencyName={currencyName}
                onBlur={grossSalaryInputBlur}
                onChange={function (event) {
                  setChangeValue(event.target.value, invoiceUser.userId, 'GROSS');
                }}
              />
              <DistributionRows.Divider />
              <DistributionRows.SelectTax
                title='OMR_KEY'
                invoiceUser={invoiceUser}
                onChange={setInvoiceUserTaxKeyId}
                disabled={disableOnLock(invoiceUser.userId)}
                options={getOmrKeys(invoiceUser.taxkeys)}
              />
              <DistributionRows.Divider />
              <DistributionRows.Tax
                calculation={getCalculationData(invoiceUser.userId, CALCULATED_TAX)}
              />
              <DistributionRows.Divider />
              <DistributionRows.Net
                invoiceUser={invoiceUser}
                value={changeValue}
                disabled={disableOnLock(invoiceUser.userId)}
                focus={focus}
                currencyName={currencyName}
                onBlur={netSalaryInputBlur}
                onChange={function (event) {
                  setChangeValue(event.target.value, invoiceUser.userId, 'NET');
                }}
              />
              <DistributionRows.Divider />
              <DistributionRows.Allowance
                invoiceUser={invoiceUser}
                value={changeValue}
                disabled={disableOnLock(invoiceUser.userId)}
                focus={focus}
                currencyName={currencyName}
                onBlur={allowanceBlur}
                onChange={function (event) {
                  setChangeValue(event.target.value, invoiceUser.userId, 'ALLOWANCE');
                }}
              />
              <DistributionRows.Divider />
              <DistributionRows.Travel
                invoiceUser={invoiceUser}
                value={changeValue}
                disabled={disableOnLock(invoiceUser.userId)}
                focus={focus}
                currencyName={currencyName}
                onBlur={travelBlur}
                onChange={function (event) {
                  setChangeValue(event.target.value, invoiceUser.userId, 'TRAVEL');
                }}
              />
              <div style={{clear: 'both'}}></div>
              <div className="details-row">
                <div className="details-top-border"></div>
              </div>
              {renderWorkerSumAccount(getCalculationData(invoiceUser.userId, CALCULATED_TO_PAY))}
              {renderWorkerSumItp(invoiceUser, getCalculationData(invoiceUser.userId, CALCULATED_ITP))}
              {renderWorkerSumVacation(invoiceUser, getCalculationData(invoiceUser.userId, CALCULATED_VACATION_GROSS))}
              {renderworkerSumTotal(invoiceUser, getCalculationData(invoiceUser.userId, CALCULATED_TOTAL))}
            </div>
          );
        })}
      </div>
    );
  }

  getCalculationData (userId, data) {
    let user;
    for (let i = 0; i<this.props.invoice.invoiceUser.length; i++) {
      if (parseInt(this.props.invoice.invoiceUser[i].userId) === parseInt(userId)) {
        user = this.props.invoice.invoiceUser[i];
        break;
      }
    }

    let originalFee = 6.0;
    let discountFee = 0;
    const invoiceUserTaxKey = user.taxkeys.find((taxkey) => +taxkey.id === user.taxkeyId);
    if (invoiceUserTaxKey) {
      originalFee = this.props.invoice.expressPayment
        ? invoiceUserTaxKey.feeExpress + invoiceUserTaxKey.feeDiscount
        : invoiceUserTaxKey.fee + invoiceUserTaxKey.feeDiscount;
      discountFee = invoiceUserTaxKey.feeDiscount;
    }

    let value;

    if (user && user.calculation) {
      switch (data) {
        case CALCULATED_ITP:
          value = +(user.calculation.itp);
          break;
        case CALCULATED_ITP_TAX:
          value = +(user.calculation.itpTax);
          break;
        case CALCULATED_VACATION_GROSS:
          value = +(user.calculation.vacationGross);
          break;
        case CALCULATED_TAX:
          value = +(user.calculation.tax);
          break;
        case CALCULATED_EXPENSE:
          value = +(user.calculation.expense);
          break;
        case CALCULATED_TO_PAY:
          value = +(user.calculation.toPay);
          break;
        case CALCULATED_TOTAL:
          value = +(user.calculation.toPay + user.calculation.itp + user.calculation.vacationGross);
          break;
        case CALCULATED_INVOICERY_FEE:
          value = +(user.calculation.amount * (originalFee / 100));
          break;
        case CALCULATED_DISCOUNT:
          value = -(user.calculation.amount * (discountFee / 100));
          break;
        case CALCULATED_PAYROLL_TAX:
          value = +(user.calculation.totalPayrollTax);
          break;
        case HOURLY_SALARY_VACATION_INCLUDED:
          value = this.getHourlySalary(user.calculation.gross + user.calculation.vacationGross);
          break;
        case HOURLY_SALARY_VACATION_EXCLUDED:
          value = this.getHourlySalaryVacationExcluded(user);
          break;
      }
    }

    if (value === undefined) {
      value = 0;
    }

    if ([HOURLY_SALARY_VACATION_INCLUDED, HOURLY_SALARY_VACATION_EXCLUDED].includes(data)) {
      return value ? toMoney(value) + ' ' + this.state.currencyName : '-';
    }

    return toMoney(value) + ' ' + this.state.currencyName;
  }

  getHourlySalaryVacationExcluded (user) {
    let value = 0;
    if (user.calculation.vacationGross === 0) {
      value = this.getHourlySalary(user.calculation.gross / 1.12);
    } else {
      value = this.getHourlySalary(user.calculation.gross);
    }
    return value;
  }

  getHourlySalary (amount) {
    const invoiceDates = this.props.invoice.invoiceDate;
    let value = 0;
    if (invoiceDates.length) {
      const hoursWorked = invoiceDates.reduce((previous, current) => previous + current.hours, 0);
      value = +(amount) / hoursWorked;
    }
    return value;
  }

  getTaxKeyIdByUserId (userId) {
    let invoiceUser;
    for (let i = 0; i<this.props.invoice.invoiceUser.length; i++) {
      if (parseInt(this.props.invoice.invoiceUser[i].userId) === parseInt(userId)) {
        invoiceUser = this.props.invoice.invoiceUser[i];
        break;
      }
    }

    return (invoiceUser && invoiceUser.taxkeyId) ? invoiceUser.taxkeyId : '';
  }

  getInvoiceOwnerAmount (userId) {
    let invoiceOwnerAmount = 0;
    let invoiceUser = this.props.invoice.invoiceUser;
    for (let i = 0; i < invoiceUser.length; i++) {
      if (invoiceUser[i].calculation && parseInt(invoiceUser[i].userId) === parseInt(userId)) {
        invoiceOwnerAmount = invoiceUser[i].calculation.amount;
        break;
      }
    }
    return invoiceOwnerAmount;
  }

  getTotalExpenses (userId) {
    let totalExpenses = 0;
    let invoiceUser = this.props.invoice.invoiceUser;
    for (let i = 0; i < invoiceUser.length; i++) {
      if (invoiceUser[i].calculation && parseInt(invoiceUser[i].userId) === parseInt(userId)) {
        totalExpenses = invoiceUser[i].calculation.expense;
        break;
      }
    }
    return totalExpenses;
  }

  renderError () {
    if (!InvoiceValidator.validatePositiveAmount(this.props.invoice.invoiceUser)) {
      return (<p className="error"><Translate content='INVOICE_ERROR_NEGATIVE_SALARY' /></p>);
    }
  }

  renderSumAccount (user, value) {
    const slimBox = user.saveVacationPay || user.saveITP || user.saveItp ? ' slim' : '';
    return (<div className='green-box'>
      <div className={'left-bg' + slimBox}>
        <span>
          <Translate className="bold" content='TO_PAY_TO_MY_ACCOUNT'/>
        </span>
      </div>
      <div className={'right-bg' + slimBox}>
        <span className="bold">
          {value}
        </span>
      </div>
    </div>);
  }
  renderSumItp (user, value) {
    if (user.saveITP || user.saveItp) {
      return (<div className='green-box light'>
        <div className='left-bg slim'>
          <Translate className='dark' content='ORDER_TOOL_TO_BE_PAID_ITP'/>
          <span>
            <ToolTip id='toSaveToItp'
              buttonClasses='tooltip-info-button'
              msg={proxyCounterpart('TOOLTIP_ORDER_TOOL_TO_BE_PAID_ITP')}/>
          </span>
        </div>
        <div className='right-bg slim'>
          <span className='dark'>
            + {value}
          </span>
        </div>
      </div>);
    }
  }
  renderSumVacation (user, value) {
    if (user.saveVacationPay) {
      return (<div className='green-box light'>
        <div className='left-bg slim'>
          <Translate className='dark' content='ORDER_TOOL_TO_BE_PAID_VACATION'/>
          <span>
            <ToolTip id='toSaveToVacation'
              buttonClasses='tooltip-info-button'
              msg={proxyCounterpart('TOOLTIP_ORDER_TOOL_TO_BE_PAID_VACATION')}/>
          </span>
        </div>
        <div className='right-bg slim'>
          <span className='dark'>
            + {value}
          </span>
        </div>
      </div>);
    }
  }

  renderSumTotal (user, value) {
    if (user.saveVacationPay || user.saveITP || user.saveItp) {
      return (<div className='green-box white'>
        <div className='left-bg slim'>
          <Translate className='dark' content='ORDER_TOOL_TO_BE_PAID_TOTAL'/>
        </div>
        <div className='right-bg slim'>
          <span className='dark'>
            = {value}
          </span>
        </div>
      </div>);
    }
  }

  renderWorkerSumAccount (value) {
    return (<div className='green-box'>
      <div className='left-bg slim'>
        <Translate className='bold' content='TO_PAY_WORKER'/>
      </div>
      <div className='right-bg slim'>
        <span className='bold'>{value}</span>
      </div>
    </div>);
  }

  renderWorkerSumItp (user, value) {
    if (user.saveITP || user.saveItp) {
      return (<div className='green-box light'>
        <div className='left-bg slim'>
          <Translate className='dark' content='ORDER_TOOL_TO_BE_PAID_ITP_WORKER'/>
        </div>
        <div className='right-bg slim'>
          <span className='dark'>+ {value}</span>
        </div>
      </div>);
    }
  }

  renderWorkerSumVacation (user, value) {
    if (user.saveVacationPay) {
      return (<div className='green-box light'>
        <div className='left-bg slim'>
          <Translate className='dark' content='ORDER_TOOL_TO_BE_PAID_VACATION_WORKER'/>
        </div>
        <div className='right-bg slim'>
          <span className='dark'>+ {value}</span>
        </div>
      </div>);
    }
  }

  renderworkerSumTotal (user, value) {
    if (user.saveVacationPay || user.saveITP || user.saveItp) {
      return (<div className='green-box white'>
        <div className='left-bg slim'>
          <Translate className='dark' content='ORDER_TOOL_TO_BE_PAID_TOTAL_WORKER'/>
        </div>
        <div className='right-bg slim'>
          <span className='dark'>= {value}</span>
        </div>
      </div>);
    }
  }

  getOutlaySum (supplierLedgers) {
    let sum = 0;

    for (let s of supplierLedgers) {
      sum += parseFloat(s.amount);
    }

    return sum;
  }

  renderOutlaySum () {
    let sum = this.getOutlaySum(this.props.invoice.supplierLedger);
    return (<span>{toMoney(sum)} {this.state.currencyName}</span>);
  }

  renderLockAmountContainer (hide, userId) {
    return (
      <div className={'lock-amount-container ' + hide}>
        <ToolTip id='checkbox' msg={proxyCounterpart('TOOLTIP_CHECKBOX')}/>
        <p data-tip={proxyCounterpart('LOCK_AMOUNT')}>
          <input
            type='checkbox'
            name='lock-amount-distribution'
            id={'lock-amount-distribution-' + userId}
            ref={'lock-amount-distribution-' + userId}
            onClick={this.lockAmountDistributionClick} />
          <label htmlFor={'lock-amount-distribution-' + userId}><span></span></label>
        </p>
      </div>
    );
  }

  closeLowHourlySalaryModal () {
    this.setState({
      showLowHourlySalaryModal: false
    });
  }

  renderLowHourlySalaryModal () {
    const invoiceUser = this.props.invoice.invoiceUser[0];

    if (invoiceUser.calculation) {
      const hourlySalary = this.getHourlySalaryVacationExcluded(invoiceUser);
      const lowHourlySalaryAmount = getLowHourlySalaryAmount(this.props.user);
      const gross = invoiceUser.calculation.gross;
      const amount = invoiceUser.calculation.amount;
      const hours = gross / hourlySalary;
      const hoursNeeded = gross / lowHourlySalaryAmount;
      const amountNeeded = (amount / hoursNeeded) * hours;

      if (this.state.showLowHourlySalaryModal &&
        hourlySalary !== 0 &&
        hourlySalary < lowHourlySalaryAmount
      ) {
        return <CloseModal
          headline={proxyCounterpart('LOW_HOURLY_SALARY_MODAL_TITLE')}
          body={proxyCounterpart(
            'LOW_HOURLY_SALARY_MODAL_BODY',
            {
              minimumHourlySalary: lowHourlySalaryAmount,
              currentHourlySalary: `${toMoney(hourlySalary)}`,
              addAmount: `${toMoney(amountNeeded - amount)}`,
              removeHours: `${toMoney(hours - hoursNeeded)}`
            }
          )}
          close={this.closeLowHourlySalaryModal}
        />;
      }
    }
  }

  render () {
    let coworkers = this.getCoworkers.bind(this);
    let getOmrKeys = this.getOmrKeys;
    let getCalculationData = this.getCalculationData;
    let setUserTaxKeyId = this.setUserTaxKeyId;
    let disableOnLock = this.disableOnLock;

    const invoiceUser = this.props.invoice.invoiceUser
      .find((invoiceUser) => +invoiceUser.userId === +this.props.user.id);
    if (invoiceUser) {
      const taxkey = invoiceUser.taxkeys.find((taxkey) => +taxkey.id === invoiceUser.taxkeyId);
      let discount;
      if (taxkey) {
        discount = +taxkey.feeDiscount;
      }
      return (
        <div className='distribution-holder'>
          <div>
            <h3 className='form-header'><span>3</span> <Translate content='MONEY_DISTRIBUTION'/></h3>
            <p><Translate content={this.props.translationPrefix + 'MONEY_DISTRIBUTION_TEXT'} /></p>
          </div>
          <div className='distribution'>
            <div className='hide-show-details'>
              <div className='showDetails' ref={'showDetails'} onClick={this.toggleDetails}>
                + <Translate content='SHOW_DETAILS'/>
              </div>
              <div className='hideDetails' ref={'hideDetails'} onClick={this.toggleDetails}>
                - <Translate content='HIDE_DETAILS'/>
              </div>
            </div>
            <div className='details detailsDisplayNone' ref={'details'}>
              <div className='invoice-amount'>
                <div className='details-left'>
                  <Translate className='bold' content='AMOUNT_TO_BILL_EXCL_VAT'/>
                  {this.renderLockAmountContainer('hide-until-mobile', invoiceUser.userId)}
                </div>
                <div className='details-right'>
                  {this.renderLockAmountContainer('hide-mobile', invoiceUser.userId)}
                  <div className='currency-input-holder' data-currency={this.state.currencyName}>
                    <input
                      type='text'
                      id={'invoice-amount-' + invoiceUser.userId}
                      ref={'invoice-amount-' + invoiceUser.userId}
                      onBlur={this.amountInputBlur}
                      defaultValue={'0'}
                      disabled={disableOnLock(invoiceUser.userId)}
                      onClick={this.focus}
                    />
                  </div>
                </div>
              </div>
              <DistributionRows.AddCoworker onClick={this.onOpenAddCoworkerModal} />
              <SupplierLedger currencyName={this.state.currencyName} />
              <DistributionRows.Divider />
              <DistributionRows.DeductionAmount calculation={this.renderOutlaySum()} />
              <DistributionRows.Divider />
              <DistributionRows.Allowance
                invoiceUser={invoiceUser}
                value={this.state.changeValue}
                disabled={disableOnLock(invoiceUser.userId)}
                focus={this.focus}
                currencyName={this.state.currencyName}
                onBlur={this.allowanceBlur}
                onChange={function (event) {
                  this.setChangeValue(event.target.value, invoiceUser.userId, 'ALLOWANCE');
                }}
                tooltipMessage='TOOLTIP_ALLOWANCE'
              />
              <DistributionRows.Divider />
              <DistributionRows.Travel
                invoiceUser={invoiceUser}
                value={this.state.changeValue}
                disabled={disableOnLock(invoiceUser.userId)}
                focus={this.focus}
                currencyName={this.state.currencyName}
                onBlur={this.travelBlur}
                onChange={function (event) {
                  this.setChangeValue(event.target.value, invoiceUser.userId, 'TRAVEL');
                }}
              />
              <DistributionRows.Divider />
              <DistributionRows.ToggleSummation
                onClick={this.toggleCalculation}
                hideCalculation={this.state.hideCalculation}
              />
              <div className='calculationDisplayNone' ref={'calculation'}>
                <div className='arrow'>
                  <DistributionRows.InvoiceryFee
                    calculation={getCalculationData(invoiceUser.userId, CALCULATED_INVOICERY_FEE)}
                  />
                  <DistributionRows.RewardsDiscount
                    calculation={getCalculationData(invoiceUser.userId, CALCULATED_DISCOUNT)}
                    discount={discount}
                  />
                  <DistributionRows.Divider
                    hide
                    discount={discount}
                  />
                  <DistributionRows.PayrollTax
                    calculation={getCalculationData(invoiceUser.userId, CALCULATED_PAYROLL_TAX)}
                  />
                  <DistributionRows.Divider />
                  <DistributionRows.PensionTax
                    calculation={getCalculationData(invoiceUser.userId, CALCULATED_ITP_TAX)}
                  />
                  <DistributionRows.Divider />
                  <DistributionRows.Pension
                    calculation={getCalculationData(invoiceUser.userId, CALCULATED_ITP)}
                  />
                  <DistributionRows.Divider />
                  <DistributionRows.Gross
                    invoiceUser={invoiceUser}
                    value={this.state.changeValue}
                    disabled={disableOnLock(invoiceUser.userId)}
                    focus={this.focus}
                    currencyName={this.state.currencyName}
                    onBlur={this.grossSalaryInputBlur}
                    onChange={function (event) {
                      this.setChangeValue(event.target.value, invoiceUser.userId, 'GROSS');
                    }}
                    tooltipMessage={proxyCounterpart('TOOLTIP_GROSS')}
                  />
                  <DistributionRows.HourlySalary
                    title='CALCULATION_HOURLY_SALARY_VACATION_INCLUDED'
                    calculation={getCalculationData(invoiceUser.userId, HOURLY_SALARY_VACATION_INCLUDED)}
                  />
                  <DistributionRows.HourlySalary
                    title='CALCULATION_HOURLY_SALARY_VACATION_EXCLUDED'
                    calculation={getCalculationData(invoiceUser.userId, HOURLY_SALARY_VACATION_EXCLUDED)}
                  />
                  <DistributionRows.Divider />
                  <DistributionRows.Tax calculation={getCalculationData(invoiceUser.userId, CALCULATED_TAX)} />
                  <DistributionRows.Divider />
                  <DistributionRows.SelectTax
                    title='OMR_KEY'
                    invoiceUser={invoiceUser}
                    onChange={setUserTaxKeyId}
                    disabled={disableOnLock(invoiceUser.userId)}
                    options={getOmrKeys(this.props.taxkeys)}
                  />
                  <DistributionRows.Divider />
                  <DistributionRows.Vacation
                    saveVacation={!!this.props.user.saveVacationPay}
                    calculation={getCalculationData(invoiceUser.userId, CALCULATED_VACATION_GROSS)}
                  />
                  <DistributionRows.Divider
                    hide
                    saveVacationPay={!!this.props.user.saveVacationPay}
                  />
                  <DistributionRows.Net
                    invoiceUser={invoiceUser}
                    value={this.state.changeValue}
                    disabled={disableOnLock(invoiceUser.userId)}
                    focus={this.focus}
                    currencyName={this.state.currencyName}
                    onBlur={this.netSalaryInputBlur}
                    onChange={function (event) {
                      this.setChangeValue(event.target.value, invoiceUser.userId, 'NET');
                    }}
                    tooltipMessage={proxyCounterpart('TOOLTIP_NET')}
                  />
                </div>
              </div>
              <div style={{clear: 'both'}}/>
              <div>
                {this.renderSumAccount(this.props.user, getCalculationData(invoiceUser.userId, CALCULATED_TO_PAY))}
                {this.renderSumItp(this.props.user, getCalculationData(invoiceUser.userId, CALCULATED_ITP))}
                {this.renderSumVacation(
                  this.props.user,
                  getCalculationData(invoiceUser.userId, CALCULATED_VACATION_GROSS)
                )}
                {this.renderSumTotal(this.props.user, getCalculationData(invoiceUser.userId, CALCULATED_TOTAL))}
              </div>
              {coworkers()}
            </div>
            <div className='showSummation' ref={'showSummation'}>
              {this.renderSumAccount(this.props.user, getCalculationData(invoiceUser.userId, CALCULATED_TO_PAY))}
              {this.renderSumItp(
                this.props.user,
                getCalculationData(invoiceUser.userId, CALCULATED_ITP)
              )}
              {this.renderSumVacation(
                this.props.user, getCalculationData(invoiceUser.userId, CALCULATED_VACATION_GROSS)
              )}
              {this.renderSumTotal(this.props.user, getCalculationData(invoiceUser.userId, CALCULATED_TOTAL))}
            </div>
            {this.renderError()}
          </div>
          {this.renderAddCoworkerModal()}
          {this.renderAddNewCoworkerModal()}
          {this.renderLowHourlySalaryModal()}
        </div>
      );
    }
    return <div></div>;
  }
}

export default Distribution;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/distribution/distribution.js
 **/